var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 31,
    viewBox: "0 0 49 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(-0.412)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1101",
    "data-name": "Rectangle 1101",
    width: 49,
    height: 31,
    rx: 5,
    transform: "translate(0.412)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-link",
    "data-name": "Icon metro-link",
    d: "M11.1,14.185a.988.988,0,0,1-.7-.29,4.659,4.659,0,0,1,0-6.581L14.06,3.652a4.653,4.653,0,1,1,6.581,6.581l-1.674,1.674a.992.992,0,0,1-1.4-1.4l1.674-1.674a2.67,2.67,0,0,0-3.776-3.776L11.8,8.716a2.673,2.673,0,0,0,0,3.776.992.992,0,0,1-.7,1.693ZM7.587,21.36A4.653,4.653,0,0,1,4.3,13.417L5.97,11.743a.992.992,0,0,1,1.4,1.4L5.7,14.819a2.67,2.67,0,0,0,3.776,3.776l3.662-3.661a2.673,2.673,0,0,0,0-3.776.992.992,0,1,1,1.4-1.4,4.659,4.659,0,0,1,0,6.581L10.877,20a4.623,4.623,0,0,1-3.29,1.363Z",
    transform: "translate(12.564 4.093)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.a67af3a26875f0aa43708dbfb32248d1.svg";
export { ForwardRef as ReactComponent };